<template>
  <section>
    <v-dialog
      v-model="dialog"
      width="800px">
      <div class="dialog-container">
        <div class="dialog-header">
          <h2>New HD Transfer Ticket</h2>
          <div class="btn-container">
            <v-button
              size="small"
              @click="handleCancle">Cancel</v-button>
            <v-button
              size="small"
              type="primary"
              @click="handlerCreate">Create</v-button>
          </div>
        </div>
        <el-form
          ref="form"
          :model="formData"
          :rules="rules">
          <div class="dialog-content flex">
            <div class="left">
              <div
                v-if="isCreateTicket"
                class="form-item pd-b-30">
                <el-form-item
                  ref="merchant_platform"
                  :rules="rules.select"
                  prop="merchant_platform">
                  <select-quote-type v-model.number="formData.merchant_platform"></select-quote-type>
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Assignee</span>-->
                <el-form-item
                  prop="assignee_id"
                  label="Assignee">
                  <v-select
                    v-model="formData.assignee_id"
                    :disabled="formData.assignee_id>0"
                    :list="globalOptions.assignee" />
                </el-form-item>
              </div>
              <div
                v-if="isCreateTicket"
                class="form-item">
                <span>{{ isFina?'Referrer':'Customer' }}</span>

                <el-form-item
                  prop="customer_id"
                  :rules="rules.select"
                >
                  <v-button
                    :icon="isFina?'user-tie':'user-circle'"
                    gray
                    @click="handlerSelectAccount">{{isFina?btn_refer_text:btn_text}}</v-button>
                </el-form-item>
              </div>
            </div>
            <div class="right">
              <div class="form-item">
                <!--              <span>Transfer Amount</span>-->
                <el-form-item
                  prop="cashout_type"
                  label="Transfer Type">
                  <v-radio-group
                    v-model="formData.cashout_type"
                    block
                    :list="cashout_list"
                  />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Transfer Amount</span>-->
                <el-form-item
                  prop="money"
                  label="Transfer Amount">
                  <v-input
                    v-model="formData.money"
                    :integerCount="6"
                    key-number
                    int />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank Account Holder</span>-->
                <el-form-item
                  prop="card_holder"
                  label="Bank Account Holder">
                  <v-input
                    v-model="formData.card_holder"
                    uppercase />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank</span>-->
                <el-form-item
                  prop="bank_code"
                  label="Bank">
                  <v-select
                    v-model="formData.bank_code"
                    valueKey="bank_code"
                    labelKey="bank_name"
                    :list="bankCashoutList" />
                </el-form-item>
              </div>
              <div class="form-item">
                <!--              <span>Bank Account No.</span>-->
                <el-form-item
                  prop="card_number"
                  label="Bank Account No.">
                  <v-input v-model="formData.card_number" />
                </el-form-item>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </v-dialog>
    <send-email-sms
      ref="send-email-sms"
      :initContent="initContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :form="customerData"
      updateContent
      @send="handlerSend"
      @skip="handlerSend"></send-email-sms>
    <attach-customer
      ref="attachCustomer"
      :customer-type="formData.merchant_platform"
      is-all-type
      @handlerSelectCustomer="handlerSelectCustomer"></attach-customer>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import MixinFina from '@/mixins/fina'
import {createCreditTicket, getTransferContent} from '@/api/ticket'
import {mapActions, mapState} from 'vuex'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import SelectQuoteType from '@/views/components/select-quote-type'
import attachCustomer from '@/views/quoting/dialogs/attachCustomer'
import MixinBank from '@/mixins/bank'
export default {
  name: 'NewCreditTicket',
  components:{
    SendEmailSms,
    SelectQuoteType,
    attachCustomer,
  },
  mixins: [MixinOptions, MixinRules,MixinFina,MixinBank],
  props:{
    form:{
      type:Object,
      default: () => ({})
    },
    isCreateTicket:{
      type:Boolean,
      default:true
    },
    isFinaAccount:{
      type:Boolean,
      default:false
    }
  },
  data() {
    return {
      dialog:false,
      formData: {
        assignee_id: '',
        customer_id: '',
        money: '',
        card_holder: '',
        bank_code: '',
        card_number: '',
        content: '',
        is_send: 0,
        merchant_platform:1,
        cashout_type:1
      },
      banks: [],
      initContent: '',
      emailListTitle: '',
      emailTitle: '',
      customerData: {}
    }
  },
  computed: {
    ...mapState('common', ['customerOptionsPhone','customerOptionsUser','customerOptionsEmail']),
    ...mapState('account', ['selectReferCustomerData','selectCustomerData','customerId','referCustomerId']),
    isFina(){
      let {merchant_platform} = this.formData
      return Number(merchant_platform)==2
    },

  },
  watch:{
    form:{
      immediate:true,
      handler(val){
        let {bank_holder,bank_code,bank_number,customer_id}=val
        this.formData.card_holder =bank_holder
        this.formData.customer_id =customer_id
        this.formData.bank_code =bank_code
        this.formData.card_number =bank_number
        if(!this.isCreateTicket){
          this.customerData = this.form
        }
      }
    },
    // 'formData.customer_id':{
    //   immediate: true,
    //   handler(val){
    //     if(Array.isArray(this.customerOptionsUser) && this.customerOptionsUser.length){
    //       let res = this.customerOptionsUser.filter(item => item.id == val)
    //       this.customerData =  res[0] || {}
    //     }else{
    //       this.customerData = this.form || {}
    //     }
    //   }
    // }
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.formData.customer_id = val
      }
    },
    isFinaAccount:{
      immediate:true,
      handler(val){
        if(val)
          this.formData.merchant_platform = 2
      }
    },
    selectReferCustomerData:{
      immediate:true,
      handler(val){
        if(val){
          let {id} = val||{}
          this.formData.customer_id = id
        }

      }
    },

  },
  created() {
    let name = localStorage.getItem('cs_name')
    let arr = this.globalOptions.assignee||[]
    arr.some(item=>{
      if(item.name==name)
        this.formData.assignee_id = item.id
    })
    this.handleClear()
  },
  methods: {
    ...mapActions('common', ['setProductId', 'getCustomerOptionsPhone','setCustomerOptionNUll','getCustomerOptionsUser']),
    ...mapActions('account', ['setCustomerId','setSelectCustomerData','setReferCustomerId','setSelectReferCustomerData']),
    handlerSelectCustomer(){
      this.customerData = this.isFina?this.selectReferCustomerData:this.selectCustomerData
    },
    handleCancle(){
      this.handleClear()
      this.dialog =false
    },
    handleClear(){
      this.setCustomerId(null)
      this.setReferCustomerId(null)
      this.setSelectReferCustomerData(null)
      this.setSelectCustomerData(null)
    },
    handlerSelectAccount(){
      this.$refs.attachCustomer.showAttachCustomer()
    },
    // remoteMethodUser(query) {
    //   if (query !== '') {
    //     this.getCustomerOptionsUser(query)
    //   } else {
    //     this.setCustomerOptionNUll()
    //   }
    // },
    changeDialog() {
      this.dialog = !this.dialog
    },
    handlerCreate() {
      this.$refs.form.validate(async valid => {
        if(valid) {
          await this.network().getTransferContent()
          this.$refs['send-email-sms'].changeDialog()
        }
      })
    },

    handlerSend(content){
      if(content){
        this.formData.is_send = 1,
        this.formData.content = content
      }else{
        this.formData.is_send = 0,
        this.formData.content = this.initContent
      }
      // this.$refs['send-email-sms'].changeDialog()
      this.network().createCreditTicket()
    },

    network() {
      return {
        createCreditTicket: async () => {
          let params = this.formData
          const { data } = await createCreditTicket(params)
          this.handleClear()
          this.$router.push({
            path: '/tickets/detail',
            query: {
              ticket_id: data.id
            }
          })
        },

        getTransferContent: async () => {
          const {data} = await getTransferContent({
            customer_id: this.formData.customer_id
          })
          const {content, email_list_title, email_title} = data
          this.initContent = content
          this.initContent = this.initContent.replaceAll('{hold_dollar}',this.formData.money)
          this.initContent = this.initContent.replaceAll('{money}',this.formData.money/100)
          this.initContent = this.initContent.replaceAll('{holder}',this.formData.card_holder)
          let bank = this.getBankOptionName(this.formData.bank_code)
          this.initContent = this.initContent.replaceAll('{bank}',bank)
          this.initContent = this.initContent.replaceAll('{bank_number}',this.formData.card_number)
          this.emailListTitle = email_list_title
          this.emailTitle = email_title
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.dialog-container {
    padding: 15px;
    color: #616266;
    // h2 {
    //   font-size: 24px;
    // }
    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 5px 15px;
      border-bottom: 1px solid #dddfe7;
      h1 {
        font-size: 24px;
      }
    }
    .dialog-content {
      padding-top: 15px;
      & > div {
        flex: 1;
      }
      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }
      .right {
        padding-left: 15px;
      }
    }
  }
.el-select {
  width: 100%;
  /deep/ .el-input__prefix {
    display: flex;
    align-items: center;
    padding-left: 3px;
    height: 100%;
  }
  .svg-inline--fa {
    font-size: 16px;
  }
  .el-input__suffix-inner{
    i{
      height: 32px;
      line-height: 32px;
    }
  }
}
</style>
